import { defineComponent, ExtractPropTypes } from 'vue';
import { createNamespaceBem, makeStringProp, makeNumericProp } from '@/utils';

const { name, bem } = createNamespaceBem('info-item');

const infoItemProps = {
  item: Object,
  title: makeStringProp(''),
  number: makeNumericProp(''),
  text: makeStringProp(''),
};

export type InfoItemProps = ExtractPropTypes<typeof infoItemProps>;

export default defineComponent({
  name,
  props: infoItemProps,
  emits: ['click'],
  setup(props, { emit }) {
    const clickItem = () => {
      emit('click', props.item);
    };
    const formatDistance = () => {
      if (!props.number) return '';
      if (props.number > 1000) {
        const kmNumber = (Number(props.number) / 1000).toFixed(2);
        return `${kmNumber}km`;
      }
      return `${Math.round(Number(props.number))}m`;
    };
    return () => (
      <div class={bem()} onClick={clickItem}>
        <div class={bem('title')}>{props.title}</div>
        <div class={bem('info')}>
          {props.item?.distance > 0 && <span class={bem('number')}>{formatDistance()}</span>}
          <span class={bem('text')}>{props.text}</span>
        </div>
      </div>
    );
  },
});
